import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function (options) {
  tt.switchTab(options);
}, CONTAINER_NAME.BYTE);
export default switchTab;